import { render, staticRenderFns } from "./FIAT_TermsAndConditions.vue?vue&type=template&id=3d3f5878&"
import script from "./FIAT_TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./FIAT_TermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FIAT_TermsAndConditions.vue"
export default component.exports